(() => {
  'use strict';

  const root = document.querySelector('[data-nouvac-lp-dpe-v2]');
  if (!root || root.dataset.nouvacLpReady === 'true') return;
  root.dataset.nouvacLpReady = 'true';

  const approvedCampaignParameters = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'fbclid'
  ];

  const currentUrl = new URL(window.location.href);

  root.querySelectorAll('[data-nouvac-lp-cta]').forEach((cta) => {
    const href = cta.getAttribute('href');
    if (!href) return;

    try {
      const targetUrl = new URL(href, window.location.origin);
      if (targetUrl.origin !== window.location.origin) return;

      approvedCampaignParameters.forEach((parameter) => {
        const value = currentUrl.searchParams.get(parameter);
        if (value) targetUrl.searchParams.set(parameter, value);
      });

      cta.setAttribute(
        'href',
        `${targetUrl.pathname}${targetUrl.search}${targetUrl.hash}`
      );
    } catch (error) {
      return;
    }
  });

  const sticky = root.querySelector('[data-nvc-sticky]');
  const heroCta = root.querySelector('[data-nvc-hero-cta]');
  const finalDecision = root.querySelector('[data-nvc-final-decision]');
  const footer = root.querySelector('[data-nvc-lp-footer]');

  if (!sticky || !heroCta || !finalDecision || !footer) return;

  const visibility = new Map([
    [heroCta, true],
    [finalDecision, false],
    [footer, false]
  ]);

  const updateSticky = () => {
    const shouldShow =
      !visibility.get(heroCta) &&
      !visibility.get(finalDecision) &&
      !visibility.get(footer);

    sticky.classList.toggle('is-visible', shouldShow);
    sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
  };

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          visibility.set(entry.target, entry.isIntersecting);
        });
        updateSticky();
      },
      {
        threshold: 0.01
      }
    );

    visibility.forEach((value, element) => {
      observer.observe(element);
    });
  } else {
    const refreshVisibility = () => {
      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight;

      visibility.forEach((value, element) => {
        const rect = element.getBoundingClientRect();
        visibility.set(
          element,
          rect.bottom > 0 && rect.top < viewportHeight
        );
      });

      updateSticky();
    };

    window.addEventListener('scroll', refreshVisibility, { passive: true });
    window.addEventListener('resize', refreshVisibility, { passive: true });
    refreshVisibility();
  }
})();
